import axios from "axios";

const api = axios.create({
  baseURL: `https://medix-production-5f4f.up.railway.app/api/`, //YOUR_API_URL HERE
  // baseURL: `https://medix-oqmn.onrender.com/api/`, //YOUR_API_URL HERE
  // baseURL: `http://localhost:3000/api/`, //YOUR_API_URL HERE
  headers: {
    "Content-Type": "application/json",
  },
});
export default api;


